import { render, staticRenderFns } from "./common-tab.vue?vue&type=template&id=8a7768dc&lang=html&"
import script from "./common-tab.vue?vue&type=script&lang=js&"
export * from "./common-tab.vue?vue&type=script&lang=js&"
import style0 from "./common-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports